import Icon from '../components/Icon.vue'

Icon.register({
  'window-restore': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M512 48v288c0 26.5-21.5 48-48 48h-48v-208c0-44.1-35.9-80-80-80h-208v-48c0-26.5 21.5-48 48-48h288c26.5 0 48 21.5 48 48zM384 176v288c0 26.5-21.5 48-48 48h-288c-26.5 0-48-21.5-48-48v-288c0-26.5 21.5-48 48-48h288c26.5 0 48 21.5 48 48zM316 204c0-6.6-5.4-12-12-12h-228c-6.6 0-12 5.4-12 12v52h252v-52z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/window-restore.js
// module id = 2112
// module chunks = 0